import React from 'react';
import logoINE from '../../../img/logo_INE_blanco-06.png';
import * as etiquetas from '../../../ApplicationResources';
import { Col, Icon, Row } from 'antd';

class Footer extends React.Component {
    render() {
        return (
            <div className='footer_style_externo'>
                <Row type="flex" align="middle" gutter={[0, 16]} style={{marginTop: '0px', marginBottom:'0px'}}>
                    <Col xs={12} sm={12} md={3} lg={3} className='col_logo_ine'>
                        <img src={logoINE} alt="" className='footer_logo_ine'/>
                    </Col>
                    <Col xs={8} sm={8} md={2} lg={2}>
                        <Icon type="copyright" id="icon-copy"/>INE M&eacute;xico {etiquetas.anio_copyright_footer}.
                    </Col>
                    <Col xs={4} sm={4} md={1} lg={1} className='label-links'>
                        <a target="_blank" href="https://cau.ine.mx/">CAU </a>
                    </Col>
                    <Col xs={16} sm={16} md={11} lg={11} className='label_unidad_tecnica'>
                        {etiquetas.general_lbl_footer_unidad_tecnica}
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={2} className='label-version-fecha-hora'>
                        {etiquetas.hora_fecha_version}
                    </Col>
                    <Col xs={7} sm={7} md={5} lg={5} className='label-version-sistema'>
                        Versi&oacute;n del sistema {etiquetas.version_sistema_footer}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Footer;